// @ts-nocheck
// this file was patched by @terra

import { z } from 'zod';
import { ScheduledReportFrequencySchema } from '../inputTypeSchemas/ScheduledReportFrequencySchema'

/////////////////////////////////////////
// SCHEDULED REPORT RULE SCHEMA
/////////////////////////////////////////

export const ScheduledReportRuleSchema = z.object({
  frequency: ScheduledReportFrequencySchema,
  id: z.string(),
  daysOfWeek: z.number().int().array(),
  dayOfMonth: z.number().int().nullable(),
  lastDayOfMonth: z.boolean().nullable(),
  fiscalYearStartMonth: z.number().int().nullable(),
  yearlyMonth: z.number().int().nullable(),
  yearlyDay: z.number().int().nullable(),
  hour: z.number().int(),
  timezone: z.string(),
  lastRunAt: z.coerce.date().nullable(),
  nextRunAt: z.coerce.date().nullable(),
})

export type ScheduledReportRule = z.infer<typeof ScheduledReportRuleSchema>

export default ScheduledReportRuleSchema;
